import React from 'react'
import { RemittanceList } from './Remittances'

/**
 * Component for displaying and managing medical aid payment list
 * Note: This component is maintained for backward compatibility
 * and uses the refactored RemittanceList component internally
 */
const MedicalAidPaymentList = () => {
  return <RemittanceList />
}

export default MedicalAidPaymentList
